/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import Vuex from 'vuex';
import * as modules from './modules';
Vue.use(Vuex);
const store = new Vuex.Store({
    modules,
    state: {
        activeMenu: -1,
        scrollHash: '#',
    },
    mutations: {
        setActiveMenu(state, index) {
            state.activeMenu = index;
        },
        setScrollHash(state, hash) {
            state.scrollHash = hash;
        },
    },
});
export default store;
